import * as actionTypes from './actionTypes';

function handleFetchErrors(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}

const setEmail = email => {
  return { type: actionTypes.SET_EMAIL, email };
};

const resetEmail = () => {
  return { type: actionTypes.RESET_EMAIL };
};

const resetEmailError = () => {
  return { type: actionTypes.RESET_EMAIL_ERROR };
};

const checkEmail = email => dispatch => {
  dispatch({ type: actionTypes.CHECK_EMAIL_REQUEST });

  const emailEncoded = encodeURIComponent(email);
  return fetch(`${process.env.REACT_APP_API}/ott/check-email?email=${emailEncoded}`, {
    method: 'GET',
  })
    .then(handleFetchErrors)
    .then(response => response.json())
    .then(data => {
      dispatch({
        type: actionTypes.CHECK_EMAIL_SUCCESS,
        data,
      });
    })
    .catch(error => {
      dispatch({
        type: actionTypes.CHECK_EMAIL_FAILURE,
        error,
      });
    });
};

const createToken = email => dispatch => {
  dispatch({ type: actionTypes.CREATE_TOKEN_REQUEST });

  const emailEncoded = encodeURIComponent(email);
  return fetch(`${process.env.REACT_APP_API}/ott/create-token?email=${emailEncoded}`, {
    method: 'POST',
  })
    .then(handleFetchErrors)
    .then(response => response.json())
    .then(data => {
      dispatch({
        type: actionTypes.CREATE_TOKEN_SUCCESS,
        data,
      });
    })
    .catch(error => {
      dispatch({
        type: actionTypes.CREATE_TOKEN_FAILURE,
        error,
      });
    });
};

const setToken = token => {
  return { type: actionTypes.SET_TOKEN, token };
};

const checkToken = token => dispatch => {
  dispatch({ type: actionTypes.CHECK_TOKEN_REQUEST });

  return fetch(`${process.env.REACT_APP_API}/ott/check-token?token=${token}`, {
    method: 'GET',
  })
    .then(handleFetchErrors)
    .then(response => response.json())
    .then(data => {
      dispatch({
        type: actionTypes.CHECK_TOKEN_SUCCESS,
        data,
      });
    })
    .catch(error => {
      dispatch({
        type: actionTypes.CHECK_TOKEN_FAILURE,
        error,
      });
    });
};

const checkPair = (msisdn, pid, token) => dispatch => {
  dispatch({ type: actionTypes.CHECK_PAIR_REQUEST });

  return fetch(
    `${process.env.REACT_APP_API}/ott/check-pair?msisdn=${msisdn}&egn=${pid}&token=${token}`,
    {
      method: 'GET',
    }
  )
    .then(handleFetchErrors)
    .then(response => response.json())
    .then(data => {
      dispatch({
        type: actionTypes.CHECK_PAIR_SUCCESS,
        data,
      });
    })
    .catch(error => {
      dispatch({
        type: actionTypes.CHECK_PAIR_FAILURE,
        error,
      });
    });
};

const setUserData = (msisdn, pid, password) => {
  return { type: actionTypes.SET_USER_DATA, msisdn, pid, password };
};

const resetUserData = () => {
  return { type: actionTypes.RESET_USER_DATA };
};

const processUser = (email, token, password, egn, id, addAddon) => dispatch => {
  dispatch({ type: actionTypes.PROCESS_USER_REQUEST });

  const emailEncoded = encodeURIComponent(email);
  const passwordEncoded = encodeURIComponent(password);
  return fetch(
    `${process.env.REACT_APP_API}/ott/process-user?email=${emailEncoded}&token=${token}&password=${passwordEncoded}&egn=${egn}&id=${id}&addAddon=${addAddon}`,
    {
      method: 'POST',
    }
  )
    .then(handleFetchErrors)
    .then(response => response.json())
    .then(data => {
      dispatch({
        type: actionTypes.PROCESS_USER_SUCCESS,
        data,
      });
    })
    .catch(error => {
      dispatch({
        type: actionTypes.PROCESS_USER_FAILURE,
        error,
      });
    });
};

const forgottenPassSetEmail = email => {
  return { type: actionTypes.FORGOTTEN_PASS_SET_EMAIL, email };
};

const forgottenPassResetResults = () => {
  return { type: actionTypes.FORGOTTEN_PASS_RESET_RESULTS };
};

const forgottenPassCheckEmail = email => dispatch => {
  dispatch({ type: actionTypes.FORGOTTEN_PASS_CHECK_EMAIL_REQUEST });

  const emailEncoded = encodeURIComponent(email);
  return fetch(
    `${process.env.REACT_APP_API}/ott/forgotten-pass-check-email?email=${emailEncoded}`,
    {
      method: 'POST',
    }
  )
    .then(handleFetchErrors)
    .then(response => response.json())
    .then(data => {
      dispatch({
        type: actionTypes.FORGOTTEN_PASS_CHECK_EMAIL_SUCCESS,
        data,
      });
    })
    .catch(error => {
      dispatch({
        type: actionTypes.FORGOTTEN_PASS_CHECK_EMAIL_FAILURE,
        error,
      });
    });
};

const forgottenPassCheckToken = token => dispatch => {
  dispatch({ type: actionTypes.FORGOTTEN_PASS_CHECK_TOKEN_REQUEST });

  return fetch(`${process.env.REACT_APP_API}/ott/forgotten-pass-check-token?token=${token}`, {
    method: 'POST',
  })
    .then(handleFetchErrors)
    .then(response => response.json())
    .then(data => {
      dispatch({
        type: actionTypes.FORGOTTEN_PASS_CHECK_TOKEN_SUCCESS,
        data,
      });
    })
    .catch(error => {
      dispatch({
        type: actionTypes.FORGOTTEN_PASS_CHECK_TOKEN_FAILURE,
        error,
      });
    });
};

const forgottenPassNewPass = (token, password) => dispatch => {
  dispatch({ type: actionTypes.FORGOTTEN_PASS_NEW_PASS_REQUEST });

  const passwordEncoded = encodeURIComponent(password);
  return fetch(
    `${process.env.REACT_APP_API}/ott/forgotten-pass-new-password?token=${token}&password=${passwordEncoded}`,
    {
      method: 'POST',
    }
  )
    .then(handleFetchErrors)
    .then(response => response.json())
    .then(data => {
      dispatch({
        type: actionTypes.FORGOTTEN_PASS_NEW_PASS_SUCCESS,
        data,
      });
    })
    .catch(error => {
      dispatch({
        type: actionTypes.FORGOTTEN_PASS_NEW_PASS_FAILURE,
        error,
      });
    });
};

const changePassSetEmail = email => {
  return { type: actionTypes.CHANGE_PASS_SET_EMAIL, email };
};

const changePassResetResults = () => {
  return { type: actionTypes.CHANGE_PASS_RESET_RESULTS };
};

const changePassCheckEmail = email => dispatch => {
  dispatch({ type: actionTypes.CHANGE_PASS_CHECK_EMAIL_REQUEST });

  const emailEncoded = encodeURIComponent(email);
  return fetch(
    `${process.env.REACT_APP_API}/ott/forgotten-pass-check-email?email=${emailEncoded}&isChange=true`,
    {
      method: 'POST',
    }
  )
    .then(handleFetchErrors)
    .then(response => response.json())
    .then(data => {
      dispatch({
        type: actionTypes.CHANGE_PASS_CHECK_EMAIL_SUCCESS,
        data,
      });
    })
    .catch(error => {
      dispatch({
        type: actionTypes.CHANGE_PASS_CHECK_EMAIL_FAILURE,
        error,
      });
    });
};

const changePassCheckToken = token => dispatch => {
  dispatch({ type: actionTypes.CHANGE_PASS_CHECK_TOKEN_REQUEST });

  return fetch(`${process.env.REACT_APP_API}/ott/forgotten-pass-check-token?token=${token}`, {
    method: 'POST',
  })
    .then(handleFetchErrors)
    .then(response => response.json())
    .then(data => {
      dispatch({
        type: actionTypes.CHANGE_PASS_CHECK_TOKEN_SUCCESS,
        data,
      });
    })
    .catch(error => {
      dispatch({
        type: actionTypes.CHANGE_PASS_CHECK_TOKEN_FAILURE,
        error,
      });
    });
};

const changePassNewPass = (token, password) => dispatch => {
  dispatch({ type: actionTypes.CHANGE_PASS_NEW_PASS_REQUEST });

  const passwordEncoded = encodeURIComponent(password);
  return fetch(
    `${process.env.REACT_APP_API}/ott/forgotten-pass-new-password?token=${token}&password=${passwordEncoded}`,
    {
      method: 'POST',
    }
  )
    .then(handleFetchErrors)
    .then(response => response.json())
    .then(data => {
      dispatch({
        type: actionTypes.CHANGE_PASS_NEW_PASS_SUCCESS,
        data,
      });
    })
    .catch(error => {
      dispatch({
        type: actionTypes.CHANGE_PASS_NEW_PASS_FAILURE,
        error,
      });
    });
};

// eslint-disable-next-line import/prefer-default-export
export {
  setEmail,
  checkEmail,
  resetEmail,
  resetEmailError,
  createToken,
  setToken,
  checkToken,
  checkPair,
  setUserData,
  resetUserData,
  processUser,
  forgottenPassSetEmail,
  forgottenPassResetResults,
  forgottenPassCheckEmail,
  forgottenPassCheckToken,
  forgottenPassNewPass,
  changePassSetEmail,
  changePassResetResults,
  changePassCheckEmail,
  changePassCheckToken,
  changePassNewPass,
};
